import type { Item } from '@/features/consignment-form/schema'

export const emptyItem: Item = {
  qty: '',
  category: '',
  description: '',
  weightKg: '',
  lengthCm: '',
  widthCm: '',
  heightCm: '',
}

/** Ids of the editor inputs; the form focuses one of them when Submit finds a row at fault. */
export const itemInputIds = {
  qty: 'item-qty',
  category: 'item-category',
  description: 'item-description',
  weightKg: 'item-weight',
  lengthCm: 'item-length',
  widthCm: 'item-width',
  heightCm: 'item-height',
} as const satisfies Record<keyof Item, string>
